export default __webpack_public_path__ + "static/media/mountains.f2a50598.svg";